module.exports = __webpack_public_path__ + "img/c23.59517352.png";